import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import theme from 'styled-theming';

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.white,
  dark: (props) => props.theme.colors.lpGhost,
});

const PanelWrapper = styled(Box)`
  border-radius: ${(props) => props.theme.radius.large};
  background-color: ${backgroundColor};
`;

function Panel(props) {
  return <PanelWrapper p={3} flexShrink={0} {...props} />;
}

export default Panel;
